import type { VaultDocumentSearchResult } from '@oneup/shared';
import { vaultApi } from '@/lib/api';

export async function VaultSearchProvider(
  query: string,
  limit = 5,
): Promise<VaultDocumentSearchResult[]> {
  const q = query.trim();
  if (!q) return [];
  const response = await vaultApi.search({ q, limit });
  return response.items;
}
